import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { formatDate, formatTime } from '../../../../utils/dateFunctions';
import { DEFAULT_TABLE_ROWS_PER_PAGE } from '../../../../utils/formValidation/commonConstants';
import { stableSort } from '../../../../utils/sortFunctions';
import ResultsTable from '../../../table/ResultsTable';

import OccProfileRow from './OccProfileRow';

const statuses = {
    200: { code: 200, message: 'Profile successfully created' },
    400: { code: 400, message: 'API Error. Please contact the system administrator' },
    401: { code: 401, message: 'API Error. Please contact the system administrator' },
    500: { code: 500, message: 'API Error. Please contact the system administrator' }
};

const headCells = [
    { id: 'eventDate', numeric: false, label: 'Date', align: 'left' },
    { id: 'time', numeric: false, label: 'Time', align: 'left' },
    { id: 'user', numeric: false, label: 'User', align: 'left' },
    { id: 'status', numeric: false, label: 'Status', align: 'left' }
];

const initialRowMetaData = {
    order: 'asc',
    orderBy: 'eventDate',
    page: 0,
    rowsPerPage: DEFAULT_TABLE_ROWS_PER_PAGE
};

const OccProfile = ({ currentParticipant }) => {
    // LOCAL STATE
    const [rows, setRows] = useState([]);
    const [rowMetaData, setRowMetaData] = useState(initialRowMetaData);

    // STORE STATE
    const users = useSelector((state) => state.entities.userService.users);
    const occProfiles = useSelector((state) => state.entities.participantService.occProfiles);

    // USEEFFECTS
    useEffect(() => {
        setRows([]);
    }, []);

    useEffect(() => {
        if (users?.length < 1 || occProfiles?.length < 1) return;
        if (occProfiles?.length && occProfiles[0].participantId !== currentParticipant.id) return;
        const rows = occProfiles?.map((el) => ({
            ...el,
            eventDate: formatDate(el.date),
            time: formatTime(el.date),
            user: users.find((entry) => entry.id === el.userId)?.emailAddress || 'zz',
            status: statuses[el.statusCode]?.message || 'zz'
        }));
        setRows(rows);
    }, [occProfiles, users]);

    // FNS
    const createRows = () =>
        stableSort(rows, rowMetaData.orderBy, rowMetaData.order).map((el) => (
            <OccProfileRow key={el.id} row={el} />
        ));

    // RENDER
    return (
        rows.length > 0 && (
            <ResultsTable
                defaultOrderBy={rowMetaData.orderBy}
                sortOrder={rowMetaData.order}
                headCells={headCells}
                passRowMetaDataUp={setRowMetaData}
                tableRows={createRows()}
                totalResults={rows.length}
            />
        )
    );
};

OccProfile.propTypes = {
    currentParticipant: PropTypes.object
};

export default OccProfile;
